import React from "react";
import { APP_PREFIX_PATH } from "configs/AppConfig";

export const gatepassRoutes = [
	{
		key: "gatepass-my-gatepass",
		exact: true,
		path: `${APP_PREFIX_PATH}/gatepass/my-gatepass`,
		component: React.lazy(() => import("views/app-views/gatepass/pages/MyGatepass")),
	},
	{
		key: "gatepass-check-out-in",
		exact: true,
		path: `${APP_PREFIX_PATH}/gatepass/check-out-in`,
		component: React.lazy(() => import("views/app-views/gatepass/pages/CheckOutIn")),
	},
];
